import {
  AllLeads as SharedAllLeads,
  FollowUpLeads as SharedFollowUpLeads,
  ConvertedLeads as SharedConvertedLeads,
  PendingLeads as SharedPendingLeads,
  RejectedLeads as SharedRejectedLeads,
} from '../admin/LeadsManagement';

export const EmployeeLeads = () => <SharedAllLeads />;
export const FollowUpLeads = () => <SharedFollowUpLeads />;
export const ConvertedLeads = () => <SharedConvertedLeads />;
export const PendingLeads = () => <SharedPendingLeads />;
export const RejectedLeads = () => <SharedRejectedLeads />;
